import {
    Tooltip,
    IconButton,
} from "@mui/material"

import ContactSupportIcon from "@mui/icons-material/ContactSupport"

import { useMenu } from "../../../contexts/MenuContext"

const SupportMenu = () => {

    const { configurableUrls } = useMenu()

    const handleMenuClick = () => {
        if (configurableUrls?.suporte) {
            window.open(
	            configurableUrls.suporte,
	            "_blank",
	            "noopener,noreferrer"
	        )
        }
    }

    return (
        <Tooltip title="Entre em contato com nosso suporte.">
            <IconButton
                onClick={handleMenuClick}
                sx={{
                    backgroundColor: "#5166a6",
                    "&:hover": {
                        backgroundColor: "#3f4e88"
                    }
                }}
            >
                <ContactSupportIcon
                    sx={{
                        color: "white",
                        fontSize: "1.25rem"
                    }}
                />
            </IconButton>
        </Tooltip>
    )
}

export default SupportMenu
